// src/components/shared/analytics/ResourceAnalytics.tsx

"use client"

import { useEffect, useMemo, useRef } from 'react'
import { sendEvent, createEngagementTimer, createEngagementStopwatch } from '~/lib/gtag'

type ResourceAnalyticsProps = {
  resourceType: 'hub' | 'category' | 'tool' | 'template' | 'analyzer' | 'generator' | 'calculator' | 'guide' | 'ebook' | 'quiz' | 'glossary'
  resourceSlug?: string
  params?: Record<string, unknown>
}

export default function ResourceAnalytics({ resourceType, resourceSlug, params }: ResourceAnalyticsProps): null {
  const getSinceLoadRef = useRef<() => number>(undefined)
  const getDeltaRef = useRef<() => number>(undefined)
  const hasSentRef = useRef(false)

  getSinceLoadRef.current ??= createEngagementTimer()
  getDeltaRef.current ??= createEngagementStopwatch()

  const baseParams = useMemo(() => ({
    resource_type: resourceType,
    ...(resourceSlug ? { resource_slug: resourceSlug } : {}),
    ...(params ?? {})
  }), [resourceType, resourceSlug, params])

  useEffect(() => {
    if (hasSentRef.current) return
    const engagementMs = Math.max(getSinceLoadRef.current ? getSinceLoadRef.current() : 1, 1)
    const action = (resourceType === 'category' || resourceType === 'hub') ? 'resource_category_view' : 'resource_view'
    // Single-fire per mount; rely on caller to place this once per page to avoid duplication
    hasSentRef.current = true
    sendEvent({ action, params: baseParams, engagement_time_msec: engagementMs })
  }, [baseParams, resourceType])

  return null
}


